import React, { useState } from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
function Arts({ lang }) {
    const [option1, setOption1] = useState(true);
    const [option2, setOption2] = useState(false);
    const [option3, setOption3] = useState(false);
    const tabList1 = [
        {
            id: 1,
            to: null,
            title: 'སྒྱུ་རྩལ།'
        },
        {
            id: 2,
            to: '/',
            title: 'ཡིག་གཟུགས་རྩམ་ཆོས།'
        },
        {
            id: 3,
            to: null,
            title: 'ཡིག་གཟུགས་འགྲེམས་སྟོན།'
        },
        {
            id: 4,
            to: null,
            title: 'རི་མོའི་རྩམ་ཆོས།'
        },
        {
            id: 5,
            to: null,
            title: 'རྒྱ་ཡིག་རྩམ་ཆོས།'
        },
        {
            id: 6,
            to: null,
            title: 'སྙ་ངག་རྩམ་ཆོས།'
        },


    ]


    const tabList2 = [
        {
            id: 7,
            to: null,
            title: 'གནའ་རབས།'
        },
        {
            id: 8,
            to: null,
            title: 'ཡིག་གཟུགས་བྱུང་འཕེལ།'
        },
        {
            id: 9,
            to: null,
            title: 'སྟག་གཟིགས་སྤུང་ཡིག །'
        },
        {
            id: 10,
            to: null,
            title: 'ཞང་ཞུང་སྨར་ཆེན་སྨར་ཆུང་།'
        },
        {
            id: 11,
            to: null,
            title: 'ཞང་ཞུང་གཟི་ཡིག །'
        },
        {
            id: 12,
            to: null,
            title: 'ལྷ་བབ་ཡི་གེ །'
        },
        {
            id: 13,
            to: null,
            title: 'ཐུ་མིའི་ཡིག་ཕུད།'
        },
        {
            id: 14,
            to: null,
            title: 'སོ་ཕག་གཤིབ་འདྲ།'
        },
        {
            id: 15,
            to: null,
            title: 'བྱ་ཕོ་འཇོལ་འདྲ།'
        },
    ]

    const tabList3 = [
        {
            id: 16,
            to: null,
            title: 'དེང་རབས།'
        },
        {
            id: 17,
            to: '/',
            title: 'ཚང་གསར་དྲབ་བྲིས།'
        },
        {
            id: 18,
            to: '/',
            title: 'ཚུག་རིང་།'
        },
        {
            id: 19,
            to: '/',
            title: 'ཀརྨ་སྒར་བྲིས།'
        },
        {
            id: 20,
            to: '/',
            title: 'སྡེར་ནང་ས་བྲིས།'
        },
        {
            id: 21,
            to: '/',
            title: 'འབྲུ་ཚ །'
        },
    ]

    return (
        <>
            <Header />
            <Container className='kyagu'>
                <div className='kyaguBody pt-4 pr-5 pl-5'>
                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                        </Col>
                    </Row>
                    {
                        lang === 'CH' ? (
                            // chinese Section
                            <>
                                <Row>
                                    <Col>
                                        <h1>Chinese Section</h1>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                                // Tibetan Section
                                <>
                                    {
                                        option1 ? (
                                            <>
                                                <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                                    <Col className='align-items-center'>
                                                        {/* Header Image */}
                                                        {/* Title */}
                                                        <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                            སྒྱུ་རྩལ།
                                            </h3>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                            <Row>
                                                                <Col sm={5} md={3}>
                                                                    <Nav variant='pills' className='flex-column '>
                                                                        {/* Tabs */}
                                                                        {
                                                                            tabList1.map((tabItem, index) => {
                                                                                return (
                                                                                    <Nav.Item className='navItem' key='id'>
                                                                                        <Nav.Link eventKey={index}>
                                                                                            <h4>{tabItem.title}</h4>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>)
                                                                            })
                                                                        }

                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(false);
                                                                            setOption2(true);
                                                                            setOption3(false);
                                                                        }}>
                                                                            <Nav.Link>
                                                                                <h4>གནའ་རབས། ➡️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(false);
                                                                            setOption2(false);
                                                                            setOption3(true);
                                                                        }}>
                                                                            <Nav.Link>
                                                                                <h4>དེང་རབས། ➡️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>

                                                                    </Nav>
                                                                </Col>

                                                                {/* Content */}
                                                                <Col sm={7} md={9}>
                                                                    <Tab.Content className='tabContent'>
                                                                        <Tab.Pane eventKey='1' className='tabPane'>

                                                                            <p>
                                                                                <h1>བོད་ཡིག་</h1>
                                                                            </p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='second' className='tabPane'>
                                                                            <p>i am Singapore</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='third' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='forth' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </Col>
                                                            </Row>
                                                        </Tab.Container>
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : option2 ? (
                                            <>
                                                <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                                    <Col className='align-items-center'>
                                                        {/* Header Image */}
                                                        {/* Title */}
                                                        <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                            སྒྱུ་རྩལ།
                                            </h3>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                            <Row>
                                                                <Col sm={5} md={3}>
                                                                    <Nav variant='pills' className='flex-column '>
                                                                        {/* Tabs */}
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(true);
                                                                            setOption2(false);
                                                                            setOption3(false);
                                                                        }}>
                                                                            <Nav.Link>
                                                                                <h4>སྒྱུ་རྩལ།️ 🔙</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                        {
                                                                            tabList2.map((tabItem, index) => {
                                                                                return (
                                                                                    <Nav.Item className='navItem' key='id'>
                                                                                        <Nav.Link eventKey={index}>
                                                                                            <h4>{tabItem.title}</h4>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>)
                                                                            })
                                                                        }
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(false);
                                                                            setOption2(false);
                                                                            setOption3(true);
                                                                        }}>
                                                                            <Nav.Link eventKey='11'>
                                                                                <h4>དེང་རབས། ➡️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                    </Nav>
                                                                </Col>

                                                                {/* Content */}
                                                                <Col sm={7} md={9}>
                                                                    <Tab.Content className='tabContent'>
                                                                        <Tab.Pane eventKey='1' className='tabPane'>

                                                                            <p>
                                                                                <h1>བོད་ཡིག་</h1>
                                                                            </p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='second' className='tabPane'>
                                                                            <p>i am Singapore</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='third' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='forth' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </Col>
                                                            </Row>
                                                        </Tab.Container>
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : option3 ? (
                                            <>
                                                <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                                    <Col className='align-items-center'>
                                                        {/* Header Image */}
                                                        {/* Title */}
                                                        <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                            སྒྱུ་རྩལ།
                                            </h3>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                            <Row>
                                                                <Col sm={5} md={3}>
                                                                    <Nav variant='pills' className='flex-column '>
                                                                        {/* Tabs */}
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(true);
                                                                            setOption2(false);
                                                                            setOption3(false);
                                                                        }}>
                                                                            <Nav.Link>
                                                                                <h4>སྒྱུ་རྩལ།️ 🔙</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>
                                                                        {
                                                                            tabList3.map((tabItem, index) => {
                                                                                return (
                                                                                    <Nav.Item className='navItem' key='id'>
                                                                                        <Nav.Link eventKey={index}>
                                                                                            <h4>{tabItem.title}</h4>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>)
                                                                            })
                                                                        }
                                                                        <Nav.Item className='navItem' onClick={() => {
                                                                            setOption1(false);
                                                                            setOption2(true);
                                                                            setOption3(false);
                                                                        }}>
                                                                            <Nav.Link>
                                                                                <h4>གནའ་རབས། ➡️</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>

                                                                    </Nav>
                                                                </Col>

                                                                {/* Content */}
                                                                <Col sm={7} md={9}>
                                                                    <Tab.Content className='tabContent'>
                                                                        <Tab.Pane eventKey='1' className='tabPane'>

                                                                            <p>
                                                                                <h1>བོད་ཡིག་</h1>
                                                                            </p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='second' className='tabPane'>
                                                                            <p>i am Singapore</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='third' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                        <Tab.Pane eventKey='forth' className='tabPane'>
                                                                            <p>i am tibet</p>
                                                                        </Tab.Pane>
                                                                    </Tab.Content>
                                                                </Col>
                                                            </Row>
                                                        </Tab.Container>
                                                    </Col>
                                                </Row>
                                            </>
                                        ) : (
                                                        null
                                                    )
                                    }

                                </>
                            )
                    }

                </div>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(Arts);
